export const NETWORK_ERROR = 'akommo-search/bootstrap/NETWORK_ERROR'

export const BOOTSTRAP = 'akommo-search/bootstrap/BOOTSTRAP'
export const BOOTSTRAPPED = 'akommo-search/bootstrap/BOOTSTRAPPED'



// WEBPACK FOOTER //
// ./src/redux/modules/bootstrap/types.js